import { Page, useCurrent } from "./common";
import { PageHead } from "../components/ui";
import EngagementDoc from "./EngagementDoc";

export default function Engagement() {
  const p = useCurrent();
  if (!p) return null;
  return (
    <Page max={820}>
      <PageHead kicker={`${p.name} · Appointment`} title="Letter of engagement" />
      <EngagementDoc p={p} mode="studio" />
    </Page>
  );
}
